import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import middlewares from './middlewares';
import persistedReducer from './persistReducer';

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend([...middlewares]),
});

export const persistor = persistStore(store);